// The header indicator. Reflects MQTT connection state and viewer presence.

import { EventType } from '../../shared/protocol.js';

export default {
  id:   'connection-status',
  slot: 'connection',
  subscribes: ({ session }) => [`sessions/${session}/presence`],
  mount({ slot, iot, bus }) {
    slot.classList.add('state-connecting');
    slot.innerHTML = `
      <span class="dot"></span>
      <span data-role="text">connecting…</span>
      <span data-role="viewers" style="margin-left:12px;color:var(--fg-muted)"></span>
    `;
    const text    = slot.querySelector('[data-role="text"]');
    const viewers = slot.querySelector('[data-role="viewers"]');

    const setState = (state, label) => {
      slot.classList.remove('state-connecting', 'state-connected', 'state-disconnected');
      slot.classList.add('state-' + state);
      text.textContent = label;
    };

    iot.onConnect    = () => setState('connected', 'connected');
    iot.onDisconnect = () => {
      const why = iot.lastError ? `disconnected: ${iot.lastError}` : 'disconnected';
      setState('disconnected', why);
    };
    iot.onError      = (e) => {
      console.warn('[iot]', e);
      setState('disconnected', 'error: ' + (e?.message || e));
    };

    // Track viewer presence — last-seen timestamp per clientId.
    const lastSeen = new Map();
    const updateViewers = () => {
      const cutoff = Date.now() - 12_000; // 2 missed heartbeats
      let n = 0;
      for (const [k, ts] of lastSeen) {
        if (ts < cutoff) lastSeen.delete(k);
        else n++;
      }
      viewers.textContent = n ? `· ${n} viewer${n === 1 ? '' : 's'}` : '';
    };
    setInterval(updateViewers, 2_000);

    const onPresence = (p) => {
      if (p?._meta?.from === 'viewer') {
        if (p.state === 'offline') lastSeen.delete(p.clientId);
        else lastSeen.set(p.clientId, Date.now());
        updateViewers();
      }
    };
    bus.on(EventType.PRESENCE_ONLINE,    onPresence);
    bus.on(EventType.PRESENCE_HEARTBEAT, onPresence);
    bus.on(EventType.PRESENCE_OFFLINE,   onPresence);
  },
};
